import { IRacketData } from './paymentItemsBuilder';
import { RootState } from '@/redux/store';

export function getArenasNames(state: RootState): IRacketData {
  const racketData: IRacketData = {};
  
  const rentState = state.rent;
  
  if (rentState && (rentState as any).arenas) {
    const arenas = (rentState as any).arenas;
    
    arenas.forEach((arena: any) => {
      if (arena.courts) {
        arena.courts.forEach((court: any) => {
          if (court.courtId) {
            racketData[court.courtId] = {
              racketServiceVAT: court.racketServiceVAT,
              courtType: court.courtType || arena.courtType,
            };
          }
        });
      }
    });
  }
  
  return racketData;
}
